import { uniqBy } from "lodash";
import { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";

export default function CustomValueMultiSelect({ defaultOptions, onChange, disabled, prefixValue }) {
    const [value, setValue] = useState(defaultOptions);

    useEffect(() => {
        setValue(defaultOptions);
    }, [defaultOptions]);

    const handleCreate = (inputValue) => {
        const clean = inputValue.trim();

        const formatted = prefixValue
            ? `${prefixValue}:${clean}`
            : clean;

        const newOption = {
            label: formatted,
            value: formatted,
        };

        setValue((prev) => {
            const newVal = uniqBy([...prev, newOption], "value"); // 🔥 remove duplicates
            onChange?.(newVal);
            return newVal;
        });
    };

    return (
        <CreatableSelect
            isMulti
            value={value}
            onChange={(val) => {
                console.log(val)
                setValue(val);
                onChange?.(val);
            }}
            onCreateOption={handleCreate}
            className={disabled ? "opacity-50" : ""}
            placeholder="Type gamecode and press Enter"
            noOptionsMessage={() => "Type gamecode and press Enter"}
            classNamePrefix="select"
            isDisabled={disabled}
        />
    );
}